import styled, { css } from "styled-components";
import { medium, px, WHITE_BG } from "../../styles/mixins";

type CONTAINER_PROPS = {
  size: number | string;
};

export const BacklitContainer = styled.div<CONTAINER_PROPS>`
  min-width: ${({ size }) => px(size)};
  width: ${({ size }) => px(size)};
  height: ${({ size }) => px(size)};
  position: relative;
  margin-left: 3px;
  ${medium(css`
    margin-left: 25px;
  `)}
  .light {
    position: absolute;
    width: ${({ size }) => px(size)};
    height: ${({ size }) => px(size)};
    background-color: ${WHITE_BG};
    z-index: 1;
    box-shadow: 0 0 15px white;
    ${medium(css`
      bottom: 10px;
      right: 10px;
    `)}
    bottom: 6px;
    right: 6px;

    border-radius: 5px;
  }
  img {
    object-position: center center;
    height: 100%;
    width: 100%;
    box-shadow: -3px -3px 7px -3px rgb(0 0 0 / 70%), 4px 4px 10px -4px white;
    object-fit: cover;
    position: relative;
    z-index: 2;
    border-radius: 5px;
  }
`;
